import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import React, { Suspense } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import Cookies from "universal-cookie";

const AppComponent = React.lazy(() => import("./App"));

const Loading = () => {
  const cookies = new Cookies();
  if (cookies.get("kt_aside_toggle_state") === "on") {
    let element = document.getElementById("kt_body");
    element.classList.add("aside-minimize");
  }

  return (
    <>
      <h1 style={{ textAlign: "center", paddingTop: "35vh" }}>
        <img src={"assets/media/logos/preload.svg"} width={250} alt="loading" />
      </h1>
    </>
  );
};

ReactDOM.render(
  <Suspense fallback={<Loading />}>
    <Scrollbars>
      <AppComponent />
    </Scrollbars>
  </Suspense>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
